import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../features';
import { ErrorScreenContent } from './ErrorScreenContent';

export const ErrorScreen: React.FC = () => {
  const errorCode = useSelector((state: RootState) => state.user.serverErrorCode);

  return <ErrorScreenContent errorCode={errorCode} />;
};
